export default __webpack_public_path__ + "static/media/twitter.692a4715.svg";